import styles from './ContentPageTitle.module.scss';

function ContentPageTitle({
  title,
  pcTextAlign = 'Left',
  spTextAlign = 'Left',
}: {
  title: string;
  pcTextAlign?: 'Left' | 'Center' | 'Right';
  spTextAlign?: 'Left' | 'Center' | 'Right';
}) {
  const spAlignClassName = styles[`spTextAlign${spTextAlign}`];
  const pcAlignClassName = styles[`pcTextAlign${pcTextAlign}`];
  return <div className={`${styles.contentPageTitle} ${pcAlignClassName} ${spAlignClassName}`}>{title}</div>;
}

export default ContentPageTitle;
